import { useFela } from 'react-fela';

import { useBreakpoint } from '@/hooks/useBreakpoint';
import { ExtensionPasskeysNotification } from '@/modules/extension/components';
import { OverdueInvoiceAlert } from '@/modules/settings/components';

import { useIsViewingAsOther } from '../../hooks/useIsViewingAsOther';
import { Secrets } from '../Secrets';
import { SecretsCountAlert } from '../SecretsCountAlert';
import { SecretsDivider } from '../SecretsDivider';
import { ViewingAsPill } from '../ViewingAsPill';
import { SecretFilters } from './SecretFilters';
import { SecretsHeader } from './SecretsHeader';
import * as felaRules from './SecretsWithFilter.rules';

// Rows rest below the pill but stay visible behind it while scrolling,
// so the gap lives inside the list's scrollport instead of the wrapper.
const VIEWING_AS_LIST_GAP = 24;

export const SecretsWithFilter = () => {
    const { css } = useFela();
    const isViewingAsOther = useIsViewingAsOther();
    const isDesktop = useBreakpoint('md');

    const hasContainerFrame = isDesktop && isViewingAsOther;
    const hasListFrame = !isDesktop && isViewingAsOther;

    return (
        <div className={css(felaRules.container, hasContainerFrame && felaRules.viewingAsFrame)}>
            {isDesktop && <ViewingAsPill />}
            <SecretsHeader />
            <SecretFilters />
            <SecretsDivider />
            <OverdueInvoiceAlert />
            <SecretsCountAlert />
            <ExtensionPasskeysNotification extend={{ container: felaRules.extensionPasskeysPrompt }} />
            <div className={css(felaRules.listWrapper, hasListFrame && felaRules.viewingAsFrame)}>
                {!isDesktop && <ViewingAsPill />}
                <Secrets paddingTop={hasListFrame ? VIEWING_AS_LIST_GAP : undefined} />
            </div>
        </div>
    );
};
